import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-detail-boolean',
    templateUrl: './detail-boolean.component.html',
    styleUrls: ['./detail-boolean.component.scss'],
    standalone: true,
})
export class DetailBooleanComponent {
    public title = input<string>();
    public value = input<boolean | undefined>();
    public ariaLabel = input<string>();
}
